const readEnvString = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');

export const GOOGLE_CLIENT_ID = readEnvString(import.meta.env['VITE_GOOGLE_CLIENT_ID']);
export const APPLE_CLIENT_ID = readEnvString(import.meta.env['VITE_APPLE_CLIENT_ID']);

export const isGoogleAuthConfigured = GOOGLE_CLIENT_ID.length > 0;
export const isAppleAuthConfigured = APPLE_CLIENT_ID.length > 0;
export const isSocialAuthConfigured = isGoogleAuthConfigured || isAppleAuthConfigured;
